import { ref, set, push, update, remove } from 'firebase/database';
import { db } from '../config/firebase';
import { TravelEntry } from '../types/travel';

export async function addTravelEntry(
  tripId: string,
  entry: Omit<TravelEntry, 'entryId' | 'createdAt'>
): Promise<string> {
  const entryRef = push(ref(db, `trips/${tripId}/travel`));
  const entryId = entryRef.key!;
  const fullEntry: TravelEntry = {
    ...entry,
    entryId,
    createdAt: Date.now(),
  };
  await set(entryRef, fullEntry);
  return entryId;
}

export async function updateTravelEntry(
  tripId: string,
  entryId: string,
  updates: Partial<TravelEntry>
): Promise<void> {
  await update(ref(db, `trips/${tripId}/travel/${entryId}`), updates);
}

export async function deleteTravelEntry(
  tripId: string,
  entryId: string
): Promise<void> {
  await remove(ref(db, `trips/${tripId}/travel/${entryId}`));
}
